module.exports = __webpack_public_path__ + "img/001-web-design.d53ebafc.svg";